// extracted by mini-css-extract-plugin
export default {"main":"src-views-___go-to-live__main___xk1Av","title":"src-views-___go-to-live__title___nVpx2"};